export default function GenericPage({ title }: { title?: string }) {
  return (
    <div className="prose max-w-none pt-1 pb-12 container mx-auto px-4">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">{title || 'Էջը պատրաստման փուլում է'}</h2>
      <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
        <p className="text-blue-700">
          Տեղեկատվությունը շուտով կավելացվի։
        </p>
      </div>
    </div>
  );
}
